import { baseCardiovascularSchema } from '../validations/shared/cardiovascular';
const shape = baseCardiovascularSchema.shape;
const cardiovascularYesNoFields = [
    { key: 'chestPainNow', field: shape.chestPainNow },
    { key: 'sobAtRest', field: shape.sobAtRest },
];
export function buildChestPainFields({ showChestPain, showNitro, showProvOther, showPallOther, showRadiationDest }) {
    return [
        { key: 'chestPainSinceLastVisit', field: shape.chestPainSinceLastVisit },
        ...(showChestPain
            ? [
                { key: 'chestPainWhen', field: shape.chestPainWhen },
                { key: 'chestPainProvocation', field: shape.chestPainProvocation, variant: 'tags' },
                ...(showProvOther ? [{ key: 'chestPainProvocationOther', field: shape.chestPainProvocationOther }] : []),
                { key: 'chestPainPalliation', field: shape.chestPainPalliation, variant: 'tags' },
                ...(showNitro
                    ? [
                        { key: 'nitroglycerinDoses', field: shape.nitroglycerinDoses },
                        { key: 'nitroglycerinTimeToRelief', field: shape.nitroglycerinTimeToRelief },
                    ]
                    : []),
                ...(showPallOther ? [{ key: 'chestPainPalliationOther', field: shape.chestPainPalliationOther }] : []),
                { key: 'chestPainQuality', field: shape.chestPainQuality, variant: 'tags' },
                { key: 'chestPainRadiation', field: shape.chestPainRadiation },
                ...(showRadiationDest
                    ? [{ key: 'chestPainRadiationDestination', field: shape.chestPainRadiationDestination }]
                    : []),
                { key: 'chestPainSeverity', field: shape.chestPainSeverity },
                { key: 'chestPainTiming', field: shape.chestPainTiming },
                { key: 'chestPainDuration', field: shape.chestPainDuration },
                { key: 'calledAnyone', field: shape.calledAnyone, variant: 'tags' },
                { key: 'associatedSymptoms', field: shape.associatedSymptoms, variant: 'tags' },
                { key: 'chestPainNewOrRecurrent', field: shape.chestPainNewOrRecurrent },
            ]
            : []),
    ];
}
export function buildRightNowFields(showPainNowSeverity) {
    return [
        ...cardiovascularYesNoFields,
        ...(showPainNowSeverity ? [{ key: 'chestPainNowSeverity', field: shape.chestPainNowSeverity }] : []),
    ];
}
export const chfFields = [
    { key: 'weightToday', field: shape.weightToday },
    { key: 'weightLastVisit', field: shape.weightLastVisit },
    { key: 'edemaLle', field: shape.edemaLle },
    { key: 'edemaRle', field: shape.edemaRle },
    { key: 'edemaType', field: shape.edemaType },
    { key: 'sacralEdema', field: shape.sacralEdema },
    { key: 'edemaWorsening', field: shape.edemaWorsening },
    { key: 'orthopneaPillows', field: shape.orthopneaPillows },
    { key: 'orthopneaWorsening', field: shape.orthopneaWorsening },
    { key: 'pndEpisodes', field: shape.pndEpisodes },
];
export function buildPerfusionFields({ showPtLeft, showPtRight }) {
    return [
        { key: 'dpLeft', field: shape.dpLeft },
        { key: 'dpRight', field: shape.dpRight },
        ...(showPtLeft ? [{ key: 'ptLeft', field: shape.ptLeft }] : []),
        ...(showPtRight ? [{ key: 'ptRight', field: shape.ptRight }] : []),
        { key: 'capillaryLess', field: shape.capillaryLess },
    ];
}
export function buildHeartFields({ showMurmur, showHsOther }) {
    return [
        { key: 'heartSounds', field: shape.heartSounds, variant: 'tags' },
        ...(showMurmur ? [{ key: 'heartSoundsDetail', field: shape.heartSoundsDetail }] : []),
        ...(showHsOther ? [{ key: 'heartSoundsOther', field: shape.heartSoundsOther }] : []),
        { key: 'heartRate', field: shape.heartRate },
        { key: 'pacemakerIcd', field: shape.pacemakerIcd },
    ];
}
export function buildMedFields({ showMedPartial, showMedReasonOther, showSideEffects, showSideOther }) {
    return [
        { key: 'cardiacMedsTaken', field: shape.cardiacMedsTaken },
        ...(showMedPartial
            ? [
                { key: 'medPartialReason', field: shape.medPartialReason, variant: 'tags' },
                ...(showMedReasonOther ? [{ key: 'medPartialReasonOther', field: shape.medPartialReasonOther }] : []),
                ...(showSideEffects
                    ? [
                        { key: 'medSideEffects', field: shape.medSideEffects, variant: 'tags' },
                        ...(showSideOther ? [{ key: 'medSideEffectsOther', field: shape.medSideEffectsOther }] : []),
                    ]
                    : []),
            ]
            : []),
    ];
}
export function buildEducationFields({ showEduOther, showEduFollowUp }) {
    return [
        { key: 'educationTopics', field: shape.educationTopics, variant: 'tags' },
        ...(showEduOther ? [{ key: 'educationTopicsOther', field: shape.educationTopicsOther }] : []),
        { key: 'patientUnderstanding', field: shape.patientUnderstanding },
        { key: 'callUnderstanding', field: shape.callUnderstanding },
        ...(showEduFollowUp ? [{ key: 'educationFollowUpPlan', field: shape.educationFollowUpPlan }] : []),
    ];
}
export const cardiovascularStatusFields = [
    { key: 'cardiacStatus', field: shape.cardiacStatus },
    { key: 'cardiovascularNarrative', field: shape.cardiovascularNarrative },
];
export const dvtSymptomsFields = [{ key: 'dvtSymptoms', field: shape.dvtSymptoms }];
